import { type Middleware, type SWRHook, serialize, useSWRConfig } from 'swr/_internal';
import { isBun, LEGACY } from '../constants';

// import { log } from '../logger';

/**
 * Load data once on app load (avoids re-fetching on unmount/mount via page navigation).
 */
export const loadedKeys = new Set<string>();
export const loadOnce: Middleware = isBun
  ? (useSWRNext: SWRHook) => useSWRNext
  : (useSWRNext: SWRHook) => (key, fetcher, config) => {
      if (!fetcher) throw new Error('no fetcher provided');
      const k = typeof key === 'string' ? key : serialize(key)?.[0];
      const hasKey = loadedKeys.has(k);
      const cache = useSWRConfig().cache;
      const data = (k ? cache.get(k)?.data : undefined) as ReturnType<typeof fetcher>;
      const hasData = data && (Array.isArray(data) ? data.length > 0 : true);
      if (k && hasData && !loadedKeys.has(k)) {
        // log.dev('cache save:', k, data);
        loadedKeys.add(k);
      }

      return useSWRNext(key, !LEGACY && hasKey ? () => data : fetcher, config);
    };
